export const PropertiesPalletStock: string[] = [
  'palletNumber',
  'sizeMillimeters',
  'speciesSize',
  'producer',
  'excelImportSpecies',
  'excelImportVariety',
  'excelImportHarvestDate',
  'excelImportQualityControlDate',
  'excelImportPackaging',
  'excelImportPalletType',
  'excelImportTag',
  'excelImportBagType',
  'excelImportBoxSize',
  'excelImportNetWeight',
  'excelImportFridgeStorage',
  'excelImportBoxesPerPallet',
  'excelImportMark',
  'excelImportContainerNumber',
  'excelImportGrade',
  'excelImportTemptale',
  'excelImportOriginCountry',
  'excelImportLoadWeek',
  'category',
  'csg',
  'csp',
  'palletBaseCode',
  'palletBaseName',
  'palletHeight',
  'temperature',
  'siteNameCsp',
  'siteFda',
  'growerCode',
  'growerGroup',
  'labeledGrowerCode',
  'labeledGrowerCSG',
  'labeledGrowerName',
  'quarterCode',
  'quarterName',
  'commune',
  'area',
  'district',
  'speciesCode',
  'varietyCode',
  'labeledVarietyCode',
  'labeledVarietyName',
  'packageCode',
  'packageNetWight',
  'packageGrossWeight',
  'labelCode',
  'categoryCode',
  'exportable',
  'sizeCode',
  'colorCode',
  'labeledSizeCode',
  'labeledSizeName',
  'colorName',
  'subcategoryName',
  'subcategoryCode',
  'treatmentCode',
  'treatmentName',
  'grossWeight',
  'pallets',
  'dehydration',
  'packingSiteCode',
  'packingSiteName',
  'pluCode',
  'lotCode',
  'tentativeReceiverCode',
  'tentativeReceiverName',
  'processCode',
  'receptionCode',
  'receptionDate',
  'palletProcessCode',
  'palletProcessDate',
  'palletProcessType',
  'palletReceptionCode',
  'palletReceptionDate',
  'palletReceptionType',
  'inspectionCode',
  'inspectionType',
  'inspectionDate',
  'inspectionStatus',
  'inspectionCountry',
  'outputRepalletizationCode',
  'outputRepalletizationDate',
  'inputRepalletizationCode',
  'inputRepalletizationDate',
  'inputToProcessCode',
  'inputToProcessDate',
  'dispatchCode',
  'dispatchDate',
  'dispatchType',
  'inspectionEntity',
  'dispatchInspectionType',
  'exporterInstructive',
  'driverName',
  'vehiclePlate',
  'wagonPlate',
  'customsCode',
  'customsName',
  'codeShippingAgency',
  'nameShippingAgency',
  'forwarderCode',
  'forwarderName',
  'shipperCode',
  'shipperName',
  'exporterCode',
  'exporterName',
  'destinationPlantCode',
  'container',
  'hatch',
  'receiverCode',
  'receiverName',
  'consigneeCode',
  'consigneeName',
  'voyageNumber',
  'vesselCode',
  'vesselName',
  'transportTypeCode',
  'vesselType',
  'shippingCompany',
  'departurePortCode',
  'departurePort',
  'departureCountry',
  'etd',
  'departureDate',
  'departureWheel',
  'arrivalPortCode',
  'arrivalPort',
  'arrivalCountry',
  'arrivalContinent',
  'arrivalDate',
  'eta'
];
